import axios from 'axios';
import { redirectToLogin } from '@/utils/authRedirect';
import { getApiBaseUrl } from '@/utils/apiBase';

console.log('mentalLoad: VITE_API_BASE_URL (Build-Zeit):', import.meta.env.VITE_API_BASE_URL);

let baseURL = '';
try {
  const rawBase = getApiBaseUrl();
  baseURL = `${rawBase}/api`;
} catch (e) {
  console.error('VITE_API_BASE_URL fehlt (in Vercel setzen und neu deployen).', e);
  void e;
}

const http = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000
});

http.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  const token = localStorage.getItem('ml_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let authRedirected = false;
let refreshing = null;

const performRefresh = async () => {
  const refreshToken = localStorage.getItem('ml_refresh_token');
  const payload = refreshToken ? { refreshToken } : {};
  const { data } = await axios.post(`${baseURL}/auth/refresh`, payload, { timeout: 15000, withCredentials: true });
  if (data?.token) {
    localStorage.setItem('ml_token', data.token);
  }
  if (data?.refreshToken) {
    localStorage.setItem('ml_refresh_token', data.refreshToken);
  } else {
    localStorage.removeItem('ml_refresh_token');
  }
  return data?.token || null;
};

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config || {};
    const skipAuthRedirect = Boolean(originalRequest.skipAuthRedirect);

    const isRefreshCall = String(originalRequest.url || '').includes('/auth/refresh');

    if ((status === 401 || status === 403) && !originalRequest._retried && !isRefreshCall) {
      try {
        refreshing = refreshing || performRefresh();
        const newToken = await refreshing;
        refreshing = null;
        if (newToken) {
          originalRequest._retried = true;
          originalRequest.headers = originalRequest.headers ?? {};
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return http(originalRequest);
        }
      } catch (e) {
        refreshing = null;
        console.warn('Token refresh failed', e?.message || e);
      }
    }

    if ((status === 401 || status === 403) && !skipAuthRedirect && !authRedirected) {
      authRedirected = true;
      localStorage.removeItem('ml_token');
      localStorage.removeItem('ml_refresh_token');
      redirectToLogin({ reason: 'expired' });
    }
    return Promise.reject(error);
  }
);

export default http;
